var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_894_669)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_894_669",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0H0V29H29V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_894_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.209 14.7488C28.209 22.1574 22.0803 28.1801 14.499 28.1801C6.91785 28.1801 0.789062 22.1574 0.789062 14.7488C0.789062 7.3401 6.91786 1.31738 14.499 1.31738C22.0803 1.31738 28.209 7.3401 28.209 14.7488Z",
    stroke: "#F26D00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9949 8.48776V11.5363H8.54432V8.48776C8.54432 7.82429 9.09288 7.28648 9.76957 7.28648C10.4463 7.28648 10.9949 7.82429 10.9949 8.48776ZM11.1442 12.246V22.5652C11.1442 22.8843 11.5403 23.0413 11.7665 22.8118L15.644 18.8784C15.9286 18.5897 16.4006 18.5897 16.6852 18.8784L20.5627 22.8118C20.7889 23.0413 21.185 22.8843 21.185 22.5652V7.9963C21.185 7.21227 20.5367 6.57666 19.7369 6.57666H10.8404H9.76957H9.63971L9.64493 6.58053C8.62645 6.64353 7.82031 7.47333 7.82031 8.48776V11.5363V12.246H8.54432H10.9949H11.1442ZM11.8682 8.25468C11.8682 7.90822 11.7687 7.57375 11.5876 7.28648H19.7369C20.1369 7.28648 20.461 7.60428 20.461 7.9963V21.6873L17.2058 18.3851C16.6366 17.8077 15.6926 17.8077 15.1234 18.3851L11.8682 21.6873V12.1386V8.25468Z",
    fill: "#F26D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7266 11.0312H18.8109",
    stroke: "#F26D00",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7266 13.4629H18.8109",
    stroke: "#F26D00",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7266 15.895H18.8109",
    stroke: "#F26D00",
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_894_669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.0dbbc247e64e06f5fe89cdf21fb1e73c.svg";
export { ForwardRef as ReactComponent };